import { eventApi } from '@/src/entities/event/api'
import { IEvent } from '@/src/entities/event/api/interfaces'
import { JSONValue } from '@/src/shared/api'

const transformEvent = async (fetchData: Promise<JSONValue>) => {
  const event = (await fetchData) as IEvent
  const data = event.data
  return {
    slug: data?.slug,
    id: data?.id,
    meta_title: data?.meta_title,
    meta_description: data?.meta_description,
    // meta_image: !data?.preview?.mediumPreview?.endsWith('.svg')
    //   ? data?.preview?.mediumPreview
    //   : data?.exhibition_images[0]?.mediumPreview,
    meta_image:
      data?.image_for_link?.mediumPreview ||
      (!data?.preview?.mediumPreview?.endsWith('.svg')
        ? data?.preview?.mediumPreview
        : data?.exhibition_images[0]?.mediumPreview),
    booking_time: data?.booking_time || null,
    is_translatable: data?.is_translatable,

    logo: {
      desktop: {
        x2: data?.preview?.mediumPreview,
      },
    },

    title: data?.exhibition_title,
    description: data?.exhibition_description,
    second_landing_description: data?.second_landing_description,
    third_landing_description: data?.third_landing_description,
    button_text: data?.button_text,
    announcement: data?.landing_description,
    location_stand: data?.stand_place,
    location_title: data?.stand_title,
    location_address: data?.stand_address,
    latitude: data?.longitude,
    longitude: data?.latitude,
    location_image: {
      desktop: {
        x2: data?.exhibition_map_image?.mediumPreview,
      },
    },
    location_video: data?.exhibition_map_video,
    image_for_link: {
      desktop: {
        x2: data?.image_for_link?.mediumPreview || null,
      },
    },
    langs: data?.langs,
  }
}

const transformEvents = async (fetchData: Promise<JSONValue>) => {
  const event = (await fetchData) as IEvent
  const data = event.data?.landings
  const langs = event.data?.langs

  return {
    data:
      data?.map((event) => ({
        id: event.id,
        slug: event.slug,
        title: event.exhibition_title,
        description: event.exhibition_description,
        button_text: 'book a meeting',
        location_stand: event.stand_place,
        location_address: event.stand_address,
        booking_time: event?.booking_time,
        is_visible: !!event?.is_visible,
        is_visible_for_feedback: !!event?.is_visible_for_feedback,

        logo: {
          desktop: {
            x1: null,
            x2: event.preview?.mediumPreview,
            webp_x1: null,
            webp_x2: null,
          },
        },

        location_city_image: {
          desktop: {
            x1: null,
            x2: event.exhibition_city?.mediumPreview,
            webp_x1: null,
            webp_x2: null,
          },
        },
        langs,
      })) ?? [],
  }
}

export const eventModel = {
  getEventLatest: async (locale: string) => transformEvent(eventApi.fetchLatestEvent({ locale })),
  getEvent: async (slug: string, locale: string) =>
    transformEvent(eventApi.fetchEvent({ slug, locale })),
  getEvents: async (slug: string, locale: string) =>
    transformEvents(eventApi.fetchEvent({ slug, locale })),
}
